// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1ocAx","field":"styles_field__3QbEw","fieldCol":"styles_fieldCol__1PW4C","diffCol":"styles_diffCol__1VFBf","diff":"styles_diff__270PH"};